import React from 'react';
import { useParams } from 'react-router-dom';

const CareerDetailPage = () => {
  const { pathId } = useParams();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-heading font-bold mb-4">Career Detail Page</h1>
        <p className="text-slate-600">Path ID: {pathId}</p>
        <p className="text-sm text-slate-500 mt-4">This page will show detailed information about a specific career path</p>
      </div>
    </div>
  );
};

export default CareerDetailPage;